// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function FormattedDateTime(props) {
  return <ReactIntl.FormattedDate
    value={props.value}
    year={"numeric"}
    month={"numeric"}
    day={"numeric"}
    hour={"numeric"}
    minute={"numeric"}
  />;
}

let make = FormattedDateTime;

export {
  make,
}
/* react-intl Not a pure module */
